import { Component } from '@angular/core';

@Component({
  selector: 'app-user-markt-segment-section',
  standalone: true,
  imports: [],
  templateUrl: './user-markt-segment-section.component.html',
  styleUrl: './user-markt-segment-section.component.scss'
})
export class UserMarktSegmentSectionComponent {

}
